<template>
  <div style="text-align: left;">
    <h2>Update User Info</h2>
    <img :src="gravatarUrl" alt="User Avatar" class="avatar" /><br>
    <a href="https://gravatar.com/connect">Edit Profile Pic</a>
    <form @submit.prevent="updateUser">
      <br>
      <div>
        <label>Display Name</label><br>
        <input
          v-model="user.disp_name"
          type="text"
          placeholder="New Display Name"
        />
      </div>
      <br>
      <div>
        <label>Bio</label><br>
        <textarea
          v-model="user.bio"
          type="text"
          placeholder="New Bio"
          style="width: 80%; height: 50%;"
        />
      </div>
      <br>
      <div>
        <label>Email</label><br>
        <input
          v-model="user.email"
          type="email"
          placeholder="New Email"
        />
      </div>
      <br>
      <div>
        <label>Password</label><br>
        <input
          v-model="user.password"
          type="password"
          placeholder="New Password"
        />
      </div>
      <br>
      <button
        type="submit"
        class="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 transition"
      >
        Update
      </button>
    </form>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import config from '../config';
import md5 from 'md5';

export default {
  name: 'UpdateUser',
  setup() {
    const loading = ref(true);
    const error = ref(null);
    const token = sessionStorage.getItem("jwt");
    const gravatarUrl = ref("");      
    const username = sessionStorage.getItem('username');
    const user = ref({});  // user ref for fetching FROM api
    // const userInfo = ref({  // user ref to submit TO api
    //   disp_name: "",
    //   bio: "",
    //   email: "",
    //   password: "",
      // });
    function decodeHtml(html) {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    const updateUser = async () => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/users/update`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(user.value),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || "Failed to update user info.");
        }

        alert("User updated successfully!");
      } catch (error) {
        console.error("Error updating user:", error);
        alert(error.message);
      }
    };

    const fetchUser = async () => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/users/${ username }`, {
          method: 'GET',
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch user data');
        }
        const data = await response.json();
        user.value = data;
        user.value.bio = decodeHtml(user.value.bio)
        user.value.password = "" // confirming pw is empty while there is no user input
        gravatarUrl.value = `https://www.gravatar.com/avatar/${md5(user.value.email.trim().toLowerCase())}?s=200&d=identicon`;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchUser);

    return {
      loading,
      updateUser,
      user,
      gravatarUrl,
      config,
      error
    };
  }
}

</script>

<style scoped>

</style>
